import { sfOr } from 'spring-filter-query-builder';
import { escapeSfqbString } from '../sfqb';
import { sfLike } from './sfqb';

export const createSupplierNameQuery = (name: string): string => {
    const searchLabelFieldName = 'name';
    const escapedInput = escapeSfqbString(name, true);
    const separators = [' ', '-'];
    return sfOr([
        sfLike(searchLabelFieldName, `${escapedInput}*`, true), // Label starts with
        ...separators.map((separator) => sfLike(searchLabelFieldName, `*${separator}${escapedInput}*`, true)), // Or label contains a substring that starts with a separator
    ]).toString();
};

export const createSupplierCodeQuery = (code: string): string =>
    sfLike('code', `*${escapeSfqbString(code, true)}*`, true).toString();
